import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';

const SCREEN_NAME = 'GOODS_DETAIL';

/**
 * - client에 화면 이름과 instanceId를 전달합니다.
 * - setScreenName을 통해 앱이 어떤 화면이 떠있는지 인지할 수 있습니다.
 */
export const useSetScreenName = () => {
  const { instanceId } = useGoodsRoute<'GoodsDetail'>();

  useEffect(() => {
    bridge.setScreenName({ instanceId: instanceId, name: SCREEN_NAME });
  }, [instanceId]);
};
